// URL base del backend
export const API_URL = 'https://sistemafinanciero.digitaleseduproperu.com/api';

// Roles del sistema
export const ROLES = {
  ADMINISTRADOR: 'administrador',
  CONTADOR:      'contador',
  USUARIO:       'usuario',
};

// Tipos de comprobante
export const TIPOS_COMPROBANTE = [
  { value: 'factura',      label: 'Factura' },
  { value: 'boleta',       label: 'Boleta' },
  { value: 'recibo',       label: 'Recibo' },
  { value: 'nota_credito', label: 'Nota de Crédito' },
];

// Monedas
export const MONEDAS = [
  { value: 'PEN', label: 'Soles (PEN)' },
  { value: 'USD', label: 'Dólares (USD)' },
];

// Estados
export const ESTADOS = [
  { value: 'activo',    label: 'Activo' },
  { value: 'anulado',   label: 'Anulado' },
  { value: 'pendiente', label: 'Pendiente' },
];